<template>
    <div class="field">
        <div class="control">
            <div class="select">
                <select v-model="selectedRuleType">
                    <option :value="null">---</option>
                    <option v-for="availableRule in availableRules" :value="availableRule" :key="availableRule">
                        {{ translateRule(availableRule) }}
                    </option>
                </select>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { computed } from "vue";
    import { AcademyResultsRule } from "../../Api/competitorResultsApi";
    import { translateRule, useAddRuleStore } from "./addRuleStore";

    const addRuleStore = useAddRuleStore();

    const selectedRuleType = computed({
        get() {
            return addRuleStore.selectedRuleType;
        },
        set(value) {
            addRuleStore.selectedRuleType = value;
        },
    });
    const availableRules = computed(() => {
        return Object.values(AcademyResultsRule);
    });
</script>

<style scoped></style>
